import React, {createContext, useContext, useReducer} from "react";


function reducer(state, action) {
    switch (action.type) {
        case "SET_MENU":
            return action.menu;
        case "CLEAR_MENU":
            return [];
        case "TOGGLE_CATEGORY":
            const pathParts = action.path.split("/");
            const newState = {...state};
            setOpen(newState, pathParts, !action.isOpen);

            return newState;
        default:
            return state;
    }
}


function setOpen(object, path, open) {
    if (path.length === 1) {
        //when opening new thing, close all siblings
        if(open) {
            Object.keys(object.items).forEach(key => {
                object.items[key].isOpen = key === path[0];
            });
        }
        else {
            object.items[path[0]].isOpen = false;
        }
        return true;
    }
    else if (path.length === 0) {
        console.log("this should not happen, error in getting prop");
        return false;
    }
    else {
        if (object.items[path[0]]) {
            return setOpen(object.items[path[0]], path.slice(1), open);
        }
        else {
            object.items[path[0]] = {};
            return setOpen(object.items[path[0]], path.slice(1), open);
        }
    }
}

const MenuContext = createContext();

export function useMenuContext() {
    const context = useContext(MenuContext);
    if (!context) {
        throw new Error('useMenuContext must be used within MenuProvider!');
    }

    return context;
}

export function MenuProvider(props) {
    const [menu, dispatch] = useReducer(reducer, []);
    const value = { menu, dispatch };

    return <MenuContext.Provider value={value} {...props}/>
}